/**
 * Humanized label for the structural actor type (e.g. `RepositoryRole` →
 * `Role`). Returned as a fallback secondary description when the
 * server-supplied category metadata is unavailable.
 */
export function actorTypeString(actorType: string): string {
  switch (actorType) {
    case 'RepositoryRole':
    case 'OrganizationAdmin':
      return 'Role'
    case 'Integration':
      return 'App'
    case 'DeployKey':
      return ''
    case 'BusinessTeam':
      return 'Enterprise team'
    case 'EnterpriseOwner':
      return 'Role'
    case 'RepositoryMigration':
      return ''
    case 'EnterpriseRole':
      return 'Role'
    default:
      return actorType
  }
}
